import { render, staticRenderFns } from "./AssistMaterialUnitInformationRemoveBackground.vue?vue&type=template&id=03620a39&scoped=true&lang=pug&"
import script from "./AssistMaterialUnitInformationRemoveBackground.vue?vue&type=script&lang=ts&"
export * from "./AssistMaterialUnitInformationRemoveBackground.vue?vue&type=script&lang=ts&"
import style0 from "./AssistMaterialUnitInformationRemoveBackground.vue?vue&type=style&index=0&id=03620a39&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03620a39",
  null
  
)

export default component.exports